/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PageHeader from "../../../components/PageHeader";
import useForm from "../../../hooks/useForm";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getTaxSingoScheduledList } from "../../../apis/tax-portal/tax-singo/tax-singo";
import { getTaxSingoStatus } from "../../../utils/taxPortal/tax-singo";
import { ControlTable } from "../../../components/Table";
import Filters from "../../../components/Filters";
import DataComponent from "../../../components/DataComponent";
import { TAX_SINGO_STATUS_LIST } from "../../../constants/TaxPortal/TAX_SINGO";
import successChecked from "../../../assets/images/icon/success-checked.svg";
import Icon from "../../../components/Icon";
import { getParams } from "../../../utils/params";
import systemAlert from "../../../utils/systemAlert";


const TaxSingoScheduledList = (props) => {

  const history = useHistory();

  const { employee } = useSelector((store) => ({
    employee: store.Profile.employee,
  }));

  const [fields] = useState(
    [
      {
        title: "상태",
        key: "status",
        onValue: (_data, _field, datas) => {
          const { color, label } = getTaxSingoStatus(datas.status)
          return <DataComponent field={
            {
              type: 'badge',
              color,
              label
            }
          }
          />;
        },
        width: 88,
      },
      {
        title: "유형",
        key: "singoType",
        width: 145,
      },
      {
        title: "신고명",
        align: "left",
        key: "name",
        type: 'ellipsis',
        onValue: (data, _field, datas) => {
          return <>
            {datas.name}{datas.description ? <>
              <small>{datas.description}</small>
            </> : ''}
          </>
        }
      },
      {
        title: "나의 수임처",
        width: 180,
        onValue: (data, _field, datas) => {
          return <>{`신고 0개 / 전체 ${datas.taxpayerSingos.length}개`}</>
        }
      },
      {
        title: "시작일",
        type: 'date',
        key: "scheduledDate",
        sort: "desc",
        width: 130,
      },
      {
        title: "종료일",
        type: 'date',
        key: "endDate",
        sort: "desc",
        width: 130,
      },

    ]);

  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    // reSubmit,
  } = useForm({
    limit: 10,
    offset: 0,
    search: {}
  });

  useEffect(() => {
    setSubmit(submit);
    submit(form);
  }, []);

  const submit = (form) => {
    if (form.search.status === 'all') delete form.search.status
    setIsLoading(true);
    getTaxSingoScheduledList(getParams(form))
      .then((res) => {
        setList(res.data.data);
        setTotal(res.data.total)
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };



  const [filters] = useState([
    {
      title: '신고명',
      key: 'search.name'
    },
    {
      title: "상태",
      key: "search.status",
      type: "select",
      value: "all",
      options: {
        list: [
          { label: "전체", value: "all" },
          ...TAX_SINGO_STATUS_LIST
        ]
      }
    },
  ]);


  const onSelect = (data) => {
    if (data.taxpayerSingos.length > 0) {
      history.push(`/tax-portal/tax-singo?scheduledIdx=${data.idx}`);
    } else {
      systemAlert('신고가능한 수임처가 없습니다.')
    }
  }


  return (
    <div>
      <div className="tax-singo-wrap">
        <PageHeader
          title={`신고현황`}
        />
        <div className="tax-singo-description-wrap">
          <div className="tax-singo-description-text-wrap">
            <Icon src={successChecked} />
            <span className="tax-singo-description-text">
              {employee ? `${employee?.name}님의 신고현황입니다.` : ""}
            </span>
          </div>
        </div>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isLoading={isLoading}
          fields={fields}
          list={list}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          onSelect={onSelect}
        />
      </div>
    </div>
  );
};

export default TaxSingoScheduledList;
